export const GET_PARAMETERS = 'GET_PARAMETERS';
export const GET_PARAMETERS_SUCCESS = `${GET_PARAMETERS}_SUCCESS`;
export const GET_PARAMETERS_FAILURE = `${GET_PARAMETERS}_FAILURE`;

export const UPDATE_PARAMETER = 'UPDATE_PARAMETER';
export const UPDATE_PARAMETER_SUCCESS = `${UPDATE_PARAMETER}_SUCCESS`;
export const UPDATE_PARAMETER_FAILURE = `${UPDATE_PARAMETER}_FAILURE`;
